import React, { useState, useRef, useEffect } from "react";
import world from "../images/world.png";
import logo from "../images/logo.jpg";
import "../css/Header.css";
import { useNavigate } from "react-router-dom";

function Header() {
  const [showCompanyMenu, setShowCompanyMenu] = useState(false);
  const [showServicesMenu, setShowServicesMenu] = useState(false);
  const [showContact, setShowContact] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const companyMenuTimeout = useRef(null);
  const servicesMenuTimeout = useRef(null);
  const contactMenuTimeout = useRef(null);
  const navigate = useNavigate();
  const mobileMenuRef = useRef(null);

  // Close mobile menu when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target)) {
        setIsMobileMenuOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleAboutNavigation = () => {
    navigate("/aboutus");
    setIsMobileMenuOpen(false);
  };

  const handleWorkNavigation = () => {
    navigate("/howwework");
    setIsMobileMenuOpen(false);
  };

  const handleWebDNavigation = () => {
    navigate("/webD");
    setIsMobileMenuOpen(false);
  };

  const handleWebDesignNavigation = () => {
    navigate("/webDesign");
    setIsMobileMenuOpen(false);
  };

  const handleAppNavigation = () => {
    navigate("/AppD");
    setIsMobileMenuOpen(false);
  };

  const handleSoftwareNavigation = () => {
    navigate("/SoftwareD");
    setIsMobileMenuOpen(false);
  };

  const handleCRMNavigation = () => {
    navigate("/crm");
    setIsMobileMenuOpen(false);
  };

  const handleGraphicNavigation = () => {
    navigate("/graphicDesign");
    setIsMobileMenuOpen(false);
  };

  const handleAINavigation = () => {
    navigate("/AIML");
    setIsMobileMenuOpen(false);
  };

  const handleITSupportNavigation = () => {
    navigate("/SupportMaintainence");
    setIsMobileMenuOpen(false);
  };

  const handleMarketingNavigation = () => {
    navigate("/DigitalMarketing");
    setIsMobileMenuOpen(false);
  };

  const handleBlockchainNavigation = () => {
    navigate("/Blockchain&NFT");
    setIsMobileMenuOpen(false);
  };

  const handleARVRNavigation = () => {
    navigate("/ARVR");
    setIsMobileMenuOpen(false);
  };

  const handleSaasNavigation = () => {
    navigate("/Saas");
    setIsMobileMenuOpen(false);
  };

  const handleResourcesNavigation = () => {
    navigate("/HireResources");
    setIsMobileMenuOpen(false);
  };

  const handleContactNavigation = () => {
    navigate("/ContactUs");
    setIsMobileMenuOpen(false);
  };

  const handleHomeNavigation = () => {
    navigate("/");
    setIsMobileMenuOpen(false);
  };

  const handleMouseEnter = (menuSetter, timeoutRef) => {
    clearTimeout(timeoutRef.current);
    menuSetter(true);
  };

  const handleMouseLeave = (menuSetter, timeoutRef) => {
    timeoutRef.current = setTimeout(() => menuSetter(false), 100);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div className="Header">
      <img className="Header-img" src={logo} alt="Logo" onClick={handleHomeNavigation}></img>
      
      {/* Mobile Toggle Button */}
      <button className="mobile-toggle" onClick={toggleMobileMenu}>
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div className={`Header-info ${isMobileMenuOpen ? "mobile-open" : ""}`} ref={mobileMenuRef}>
        <div
          className="Header-item"
          onMouseEnter={() =>
            handleMouseEnter(setShowCompanyMenu, companyMenuTimeout)
          }
          onMouseLeave={() =>
            handleMouseLeave(setShowCompanyMenu, companyMenuTimeout)
          }
        >
          <p className="Header-p">Company</p>
          {showCompanyMenu && (
            <div
              className="Dropdown-menu"
              onMouseEnter={() =>
                handleMouseEnter(setShowCompanyMenu, companyMenuTimeout)
              }
              onMouseLeave={() =>
                handleMouseLeave(setShowCompanyMenu, companyMenuTimeout)
              }
            >
              <div className="Dropdown-box" onClick={handleAboutNavigation}>
                <i
                  style={{ marginBottom: "20px" }}
                  className="fa-regular fa-address-card fa-2xl"
                ></i>
                <p>About Us</p>
              </div>
              <div className="Dropdown-box" onClick={handleWorkNavigation}>
                <i
                  style={{ marginBottom: "20px" }}
                  className="fa-solid fa-hands-holding-child fa-2xl"
                ></i>
                <p>How We Work</p>
              </div>
              <div className="Dropdown-box">
                <i
                  style={{ marginLeft: "10px", marginBottom: "20px" }}
                  className="fa-solid fa-file-pen fa-2xl"
                ></i>
                <p>NDA</p>
              </div>
              <div className="Dropdown-box">
                <i
                  style={{ marginLeft: "5px", marginBottom: "20px" }}
                  className="fa-solid fa-building-shield fa-2xl"
                ></i>
                <p>Policies</p>
              </div>
              <div className="Dropdown-box">
                <i
                  style={{ marginBottom: "20px" }}
                  className="fa-solid fa-person-walking-luggage fa-2xl"
                ></i>
                <p>Career</p>
              </div>
            </div>
          )}
        </div>
        <div
          className="Header-item"
          onMouseEnter={() =>
            handleMouseEnter(setShowServicesMenu, servicesMenuTimeout)
          }
          onMouseLeave={() =>
            handleMouseLeave(setShowServicesMenu, servicesMenuTimeout)
          }
        >
          <p className="Header-p">Services</p>
          {showServicesMenu && (
            <div
              className="Dropdown-menu1"
              onMouseEnter={() =>
                handleMouseEnter(setShowServicesMenu, servicesMenuTimeout)
              }
              onMouseLeave={() =>
                handleMouseLeave(setShowServicesMenu, servicesMenuTimeout)
              }
            >
              <div className="Dropdown-boxes">
                <div className="Dropdown-box1" onClick={handleWebDNavigation}>
                  <i
                    style={{ marginBottom: "20px" }}
                    className="fa-solid fa-file-code fa-2xl"
                  ></i>
                  <p>Web Development</p>
                </div>
                <div className="Dropdown-box1" onClick={handleWebDesignNavigation}>
                  <i
                    style={{ marginBottom: "20px" }}
                    className="fa-solid fa-wand-magic-sparkles fa-2xl"
                  ></i>
                  <p>Web Design</p>
                </div>
                <div className="Dropdown-box1" onClick={handleAppNavigation}>
                  <i
                    style={{ marginBottom: "20px" }}
                    className="fa-brands fa-intercom fa-2xl"
                  ></i>
                  <p>App Development</p>
                </div>
                <div className="Dropdown-box1" onClick={handleSoftwareNavigation}>
                  <i
                    style={{ marginBottom: "20px" }}
                    className="fa-brands fa-uncharted fa-2xl"
                  ></i>
                  <p>Software Development</p>
                </div>
                <div className="Dropdown-box1" onClick={handleCRMNavigation}>
                  <i
                    style={{ marginBottom: "20px" }}
                    className="fa-brands fa-superpowers fa-2xl"
                  ></i>
                  <p> CRM & ERP</p>
                </div>
                <div className="Dropdown-box1" onClick={handleGraphicNavigation}>
                  <i
                    style={{ marginBottom: "20px" }}
                    className="fa-solid fa-hexagon-nodes fa-2xl"
                  ></i>
                  <p>Graphical Design</p>
                </div>
              </div>
              <div className="Dropdown-boxes">
                <div className="Dropdown-box1" onClick={handleAINavigation}>
                  <i
                    style={{ marginLeft: "2px", marginBottom: "20px" }}
                    className="fa-solid fa-robot fa-2xl"
                  ></i>
                  <p>AI & ML</p>
                </div>
                <div className="Dropdown-box1" onClick={handleITSupportNavigation}>
                  <i
                    style={{ marginBottom: "20px" }}
                    className="fa-solid fa-life-ring fa-2xl"
                  ></i>
                  <p>IT Support Maintenance</p>
                </div>
                <div className="Dropdown-box1" onClick={handleMarketingNavigation}>
                  <i
                    style={{ marginBottom: "20px" }}
                    className="fa-solid fa-people-group fa-2xl"
                  ></i>
                  <p>Digital Marketing</p>
                </div>
                <div className="Dropdown-box1" onClick={handleBlockchainNavigation}>
                  <i
                    style={{ marginBottom: "20px" }}
                    className="fa-brands fa-hive fa-2xl"
                  ></i>
                  <p>Blockchain & NFT</p>
                </div>
                <div className="Dropdown-box1" onClick={handleARVRNavigation}>
                  <i
                    style={{ marginBottom: "20px" }}
                    className="fa-solid fa-vr-cardboard fa-2xl"
                  ></i>
                  <p>Web AR & VR</p>
                </div>
                <div className="Dropdown-box1" onClick={handleSaasNavigation}>
                  <i
                    style={{ marginBottom: "20px" }}
                    className="fa-brands fa-sass fa-2xl"
                  ></i>
                  <p>Saas</p>
                </div>
              </div>
            </div>
          )}
        </div>
        <p className="Header-p">Portfolio</p>
        <p className="Header-p" onClick={handleResourcesNavigation}>Hire Resources</p>
        <p className="Header-p" onClick={handleContactNavigation}>Contact Us</p>
      </div>
      <button className="Header-button"  onClick={() => {
    navigate("/ContactUs");
    setIsMobileMenuOpen(false); // Optional: close mobile menu if open
  }}>Get a Quote</button>
      <hr className="Header-hr" />
      <div className="Header-icons">
        <i className="fa-solid fa-mobile-retro"></i>
        <i
          style={{ marginLeft: "-14px", marginTop: "-35px" }}
          className="fa-solid fa-comment-sms"
        ></i>
      </div>
      <div className="Header-contact">
        <p
          style={{
            color: "#33415c",
            fontSize: "1.3rem",
            fontWeight: "bolder",
            marginLeft: "-1px",
          }}
          className="Header-p1"
        >
          Phone Us
        </p>
        <div
          className="Header-number"
          onMouseEnter={() =>
            handleMouseEnter(setShowContact, contactMenuTimeout)
          }
          onMouseLeave={() =>
            handleMouseLeave(setShowContact, contactMenuTimeout)
          }
        >
          <img className="Header-world-img" alt="" src={world} />
          <p className="Header-p1">+91-7891266745</p>
          {showContact && (
            <div
              className="Dropdown-menu2"
              onMouseEnter={() =>
                handleMouseEnter(setShowContact, contactMenuTimeout)
              }
              onMouseLeave={() =>
                handleMouseLeave(setShowContact, contactMenuTimeout)
              }
            >
              <div className="Dropdown-box2">
                <p
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "normal",
                    marginBottom: "15px",
                  }}
                >
                  Contact Us
                </p>
                <div className="Dropdown-number">
                  <img className="Header-world-img" alt="" src={world} />
                  <p
                    style={{
                      marginBottom: "20px",
                      marginTop: "5px",
                      color: "#979dac",
                    }}
                  >
                    +91-7891266745
                  </p>
                </div>
              </div>
              <div className="Dropdown-box2">
                <p
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "normal",
                    marginBottom: "15px",
                  }}
                >
                  Other Details
                </p>
                <div className="Dropdown-details">
                  <div className="Dropdown-detail">
                    <i class="fa-brands fa-pinterest-p fa-xl"></i>
                    <p>Purohit Technosoft</p>
                  </div>
                  <div className="Dropdown-detail" style={{marginLeft:"50px"}}>
                    <i class="fa-brands fa-whatsapp fa-xl"></i>
                    <a style={{textDecoration:"none",color:"#979dac"}} href="https://wa.me/917891266745 "><p>WhatsApp</p></a>
                  </div>
                </div>
                <div className="Dropdown-detail">
                    <i class="fa-regular fa-envelope fa-xl"></i>
                    <p style={{ marginBottom: "10px" }}>
                      business@purohittechnosoft.com
                    </p>
                  </div>
                </div>
                <div className="Dropdown-box2">
                  <p
                    style={{
                      fontSize: "1.5rem",
                      fontWeight: "normal",
                      marginBottom: "15px",
                    }}
                  >
                    For HR Inquiry
                  </p>
                  <div className="Dropdown-details">
                    <div className="Dropdown-detail">
                      <i class="fa-regular fa-envelope fa-xl"></i>
                      <p>info@purohittechnosoft.com</p>
                    </div>
                  </div>
                  <div className="Dropdown-detail">
                    <i class="fa-solid fa-mobile fa-xl"></i>
                    <p style={{ marginBottom: "10px" }}>+91-7891266745</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    
  );
}

export default Header;